export default __webpack_public_path__ + "static/media/data-protection.dece88a5.png";